import React, {Component} from 'react';
import {Col, Card, Form, Row, Button, Alert} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {connect} from 'react-redux';

import * as actions from '../../../store/actions/index';
import * as validators from '../../../util/validators';
import * as filters from '../../../util/filters';
import * as inputTypes from '../../../util/inputTypes';
import * as forms from '../../../util/forms';

class SignUp extends Component {

    componentDidMount() {
        this.props.clearError();
    }

    state = {
        form: {
            email: {
                label: "Email",
                type: inputTypes.EMAIL,
                value: "",
                touched: false,
                valid: false,
                validator: validators.combineAnd(validators.requiredText, validators.isEmail),
                filter: filters.trimText
            },
            password:  {
                label: "Password",
                type: inputTypes.PASSWORD,
                value: "",
                touched: false,
                valid: false,
                validator: validators.requiredText
            },
        },
        formValid: false
    }

    onFormInputChange = (event, key) => {
        const updatedFormData = forms.updateForm(event, key, this.state.form);
        this.setState(state => updatedFormData);
    };

    onFormSubmit = (event) => {
        event.preventDefault();
        if (!this.state.formValid) return;
        this.props.signUp(this.state.form.email.value, this.state.form.password.value);
    };

    render() {

        const buildForm = () => {
            const buildFormInputs = () => {
                const buildFormInput = (formElement) => {
                    const buildTextInput = () => {
                        return (
                            <Form.Group key={formElement.id}>
                                <Form.Label>{formElement.label}</Form.Label>
                                <Form.Control
                                    type={formElement.type}
                                    value={formElement.value}
                                    placeholder={formElement.label}
                                    isValid={formElement.valid}
                                    isInvalid={formElement.touched && !formElement.valid}
                                    onChange={event => this.onFormInputChange(event, formElement.id)}/>
                            </Form.Group>
                        );
                    };
                    switch (formElement.type) {
                        case inputTypes.EMAIL:
                        case inputTypes.PASSWORD:
                            return buildTextInput();
                        default:
                            return null;
                    }
                };
                const formInputs = [];
                for (let key in this.state.form) {
                    if (this.state.form[key]) {
                        formInputs.push(buildFormInput({id: key, ...this.state.form[key]}))
                    }
                }
                return formInputs;
            };
            const buildButtonsRow = () => {
                const buildLoginButton = () => {
                    return (
                        <Col>
                            <LinkContainer to={"/login"}>
                                <Button type={"button"} variant={"warning"}>Login</Button>
                            </LinkContainer>
                        </Col>
                    );
                };
                const buildSignUpButton = () => {
                    return (
                        <Col>
                            <Button type={"submit"} disabled={!this.state.formValid}>
                                Sign Up
                            </Button>
                        </Col>
                    );
                };
                return (
                    <Row>
                        {buildSignUpButton()}
                        {buildLoginButton()}
                    </Row>
                );
            };
            return (
                <Form onSubmit={this.onFormSubmit}>
                    {buildFormInputs()}
                    {buildButtonsRow()}
                </Form>
            );
        };
        const buildError = () => {
            if (!this.props.error) return;
            return (
                <Alert variant={"danger"} className={"mt-3"}>
                    <p>{this.props.error}</p>
                </Alert>
            );
        };
        return (
            <Col xs={12} sm={{span: 8, offset: 2}}>
                <Card className={"p-3"}>
                    {buildForm()}
                </Card>
                {buildError()}
            </Col>
        );
    }
}

const mapStateToProps = state => {
    return {
        error: state.auth.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearError: () => dispatch(actions.clear_error()),
        signUp: (email, password) => dispatch(actions.signUp(email, password)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
